// How to play: the one-time welcome card after you arrive, and the Help sheet behind the "?" button.
// The game pauses while either is open.
import { useEffect, useState } from "preact/hooks";
import { helpOpen, holdClock } from "../bridge";
import { HELP, markWelcomed, tx, WELCOME } from "../help";
import { lang } from "../i18n";

export function HelpModal() {
  const mode = helpOpen.value;
  useEffect(() => {
    holdClock("help", !!mode);
    return () => holdClock("help", false);
  }, [mode]);
  if (!mode) return null;
  return mode === "welcome" ? <Welcome /> : <HelpSheet />;
}

function close() {
  markWelcomed();
  helpOpen.value = false;
}

function Welcome() {
  const pcm = lang.value === "pcm";
  return (
    <div class="modal-backdrop help-backdrop" role="dialog" aria-modal="true" aria-label="Welcome">
      <div class="modal help-card">
        <div class="help-kicker">Welcome to Degen Island 🏝️</div>
        <h3>{pcm ? "Small things to know first" : "Four things to know"}</h3>
        <ol class="help-steps">
          {WELCOME.map((s) => (
            <li key={s.icon}>
              <span class="help-icon" aria-hidden="true">
                {s.icon}
              </span>
              <div>
                <b>{tx(s.title)}</b>
                <p>{tx(s.body())}</p>
              </div>
            </li>
          ))}
        </ol>
        <button class="btn primary big" onClick={close}>
          {pcm ? "Oya, make we go" : "Let's go"}
        </button>
        <p class="fine center">{pcm ? "You fit open this again with the ? button for top." : "You can open this again any time with the ? button at the top."}</p>
      </div>
    </div>
  );
}

function HelpSheet() {
  const [open, setOpen] = useState<number | null>(0);
  const pcm = lang.value === "pcm";
  return (
    <div class="modal-backdrop help-backdrop" role="dialog" aria-modal="true" aria-label="How to play" onClick={close}>
      <div class="modal help-card help-sheet" onClick={(e) => e.stopPropagation()}>
        <div class="row-between">
          <h3>{pcm ? "How to play am" : "How to play"}</h3>
          <button class="quest-x" aria-label="Close" onClick={close}>
            ×
          </button>
        </div>
        <ol class="help-steps compact">
          {WELCOME.map((s) => (
            <li key={s.icon}>
              <span class="help-icon" aria-hidden="true">
                {s.icon}
              </span>
              <div>
                <b>{tx(s.title)}</b>
                <p>{tx(s.body())}</p>
              </div>
            </li>
          ))}
        </ol>
        <div class="help-sections">
          {HELP.map((sec, i) => (
            <section key={sec.icon} class={`help-sec ${open === i ? "open" : ""}`}>
              <button class="help-sec-head" aria-expanded={open === i} onClick={() => setOpen(open === i ? null : i)}>
                <span aria-hidden="true">{sec.icon}</span> {tx(sec.title)}
                <span class="help-chev" aria-hidden="true">
                  {open === i ? "−" : "+"}
                </span>
              </button>
              {open === i && (
                <ul>
                  {sec.lines().map((l) => (
                    <li key={l.en}>{tx(l)}</li>
                  ))}
                </ul>
              )}
            </section>
          ))}
        </div>
        <button class="btn primary" onClick={close}>
          {pcm ? "I don understand" : "Got it"}
        </button>
      </div>
    </div>
  );
}
